import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TablePagination,
  TextField,
  Typography,
  Button,
  useTheme,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Chip,
  Tooltip
} from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { Trash } from 'iconsax-react';
import { useEffect, useState } from 'react';
import ClientFilter from 'components/ClientFilter';
import useApi from 'hooks/useApi';
import useSelection from 'hooks/useSelection';
import useClientAutoSelector from 'hooks/useClientAutoSelector';
import SearchIcon from '@mui/icons-material/Search';
import MainCard from 'components/MainCard';
// import { closeSnackbar } from 'notistack';
// import InviteUserModal from 'pages/application/clients/ClientUsers/InviteUserModal';
// import ModeEditIcon from '@mui/icons-material/ModeEdit';
const Users = () => {
  const theme = useTheme();
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0); 
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [teamOptions, setTeamOptions] = useState<any[]>([]);
  const { getDashboardTags, getUsers, getTeamByClient, base64Decode } = useApi();
  const { setSelectedClient, selectedTeam, setSelectedTeam, selectedClient, clientOptions } = useSelection();
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Auto-select client if there's only one available (important for users without dashboard access)
  useClientAutoSelector();
  // const theme = useTheme();
  // const [editUserData,setEditUserData] = useState<any>(null);
  // const [open, setOpen] = useState(false);
  useEffect(() => {
    loadUsers();
  }, [selectedClient, selectedTeam, page, rowsPerPage]);

  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);
  const loadUsers = async () => {
    setLoading(true);
    let usersResp = await getUsers({
      page: page + 1,
      size: rowsPerPage,
      client: selectedClient,
      team: selectedTeam,
      search: search
    });

    let { users, count } = usersResp.data;
    setUsers(users);
    setCount(count);
    setLoading(false);
  };

  const loadTags = async () => {
    let tagsResp = await getDashboardTags();
    if (tagsResp.success) {
      // handle tags if needed
    }
  };

  useEffect(() => {
    loadTags();
  }, []);

  useEffect(() => {
    const fetchTeams = async () => {
      if (selectedClient) {
        try {
          const res = await getTeamByClient(selectedClient);
          setTeamOptions(res?.data || []);
        } catch {
          setTeamOptions([]);
        }
        setSelectedTeam(selectedTeam);
      } else {
        setTeamOptions([]);
        setSelectedTeam('');
      }
    };
    fetchTeams();
  }, [selectedClient]);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const ActionButton = styled(Button)({
  //   backgroundColor: '#fff'
  // });

  const handleSearch = () => {
    setPage(0);
    loadUsers();
  };

  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <MainCard
        sx={{
          borderRadius: 2,
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        }}
      >
        {/* Header Section */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            alignItems: { xs: 'stretch', lg: 'center' },
            justifyContent: 'space-between',
            mb: 3,
            gap: 2
          }}
        >
          {/* Title */}
          <Typography
            variant="h4"
            fontWeight={600}
            sx={{
              color: 'text.primary',
              mb: { xs: 2, lg: 0 }
            }}
          >
            Users List
          </Typography>

          {/* Filters Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'stretch', sm: 'center' },
              gap: 2,
              minWidth: { sm: 'auto', lg: '500px' }
            }}
          >
            <ClientFilter
              clientOptions={clientOptions}
              selectedClient={selectedClient}
              onChange={setSelectedClient}
              size="small" 
              sx={{ 
                minWidth: { xs: '100%', sm: 180 },
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                  }
                }
              }}
            />

            <FormControl 
              size="small" 
              sx={{ 
                minWidth: { xs: '100%', sm: 180 },
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                  }
                }
              }} 
              disabled={!selectedClient}
            >
              <InputLabel id="team-select-label">Processes</InputLabel>
              <Select
                labelId="team-select-label"
                value={selectedTeam || ''}
                label="Processes"
                onChange={(e) => setSelectedTeam(e.target.value)}
              >
                {teamOptions.map((team: any) => (
                  <MenuItem key={team.uid} value={team.uid}>
                    {team.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              placeholder="Search users..."
              variant="outlined"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={handleSearchKeyDown}
              size="small"
              sx={{
                minWidth: { xs: '100%', sm: 250 },
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                  }
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton 
                      edge="end" 
                      size="small" 
                      onClick={handleSearch}
                      sx={{ 
                        color: 'primary.main',
                        '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)' }
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <Button
              variant="outlined"
              sx={{
                borderRadius: 1.5,
                textTransform: 'none',
                fontWeight: 500,
                px: 2,
                py: 1,
                minWidth: { xs: '100%', sm: 'auto' },
                borderColor: 'grey.300',
                color: 'text.secondary',
                '&:hover': {
                  borderColor: 'primary.main',
                  backgroundColor: 'rgba(25, 118, 210, 0.04)'
                }
              }}
              onClick={() => {
                setSelectedTeam('');
                setSearch('');
                setPage(0);
                loadUsers();
              }}
            >
              Reset
            </Button>
          </Box>
        </Box>

        {/* Content Section */}
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 600 }}>
          {selectedClient ? (
            loading ? (
              <Box
                sx={{
                  flex: 1,
                  height: '600px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  bgcolor: 'grey.50',
                  borderRadius: 1,
                }}
              >
                <Typography variant="h6" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Loading Users...
                </Typography>
              </Box>
            ) : (
              <TableContainer sx={{ 
                height: '600px', // Fixed height for the table
                overflow: 'auto',
                '& .MuiTable-root': {
                  '& .MuiTableHead-root': {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1
                  }
                }
              }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell 
                        sx={{ 
                          fontWeight: 700, 
                          bgcolor: 'grey.50',
                          borderBottom: `2px solid ${theme.palette.divider}`,
                          color: 'text.primary'
                        }}
                      >
                        First Name
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontWeight: 700, 
                          bgcolor: 'grey.50',
                          borderBottom: `2px solid ${theme.palette.divider}`,
                          color: 'text.primary'
                        }}
                      >
                        Last Name
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontWeight: 700, 
                          bgcolor: 'grey.50',
                          borderBottom: `2px solid ${theme.palette.divider}`,
                          color: 'text.primary'
                        }}
                      >
                        Email Address
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontWeight: 700, 
                          bgcolor: 'grey.50',
                          borderBottom: `2px solid ${theme.palette.divider}`,
                          color: 'text.primary'
                        }}
                      >
                        Phone Number
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontWeight: 700, 
                          bgcolor: 'grey.50',
                          borderBottom: `2px solid ${theme.palette.divider}`,
                          color: 'text.primary'
                        }}
                      >
                        Role
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontWeight: 700, 
                          bgcolor: 'grey.50',
                          borderBottom: `2px solid ${theme.palette.divider}`,
                          color: 'text.primary'
                        }}
                      >
                        Processes
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontWeight: 700, 
                          bgcolor: 'grey.50',
                          borderBottom: `2px solid ${theme.palette.divider}`,
                          color: 'text.primary'
                        }}
                      >
                        Status
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users?.length > 0 ? (
                      users.map((user: any, idx: number) => (
                        <TableRow 
                          key={user.uid || idx} 
                          hover
                          sx={{
                            '&:hover': {
                              bgcolor: 'rgba(25, 118, 210, 0.04)',
                              cursor: 'pointer'
                            },
                            '& .MuiTableCell-root': {
                              borderBottom: `1px solid ${theme.palette.divider}`,
                              py: 1.5
                            }
                          }}
                        >
                          <TableCell sx={{ color: 'text.primary', fontWeight: 500 }}>
                            {user.firstName || '-'}
                          </TableCell>
                          <TableCell sx={{ color: 'text.primary', fontWeight: 500 }}>
                            {user.lastName || '-'}
                          </TableCell>
                          <TableCell sx={{ color: 'text.secondary' }}>
                            {user?.email ? base64Decode(user?.email) : '-'}
                          </TableCell>
                          <TableCell sx={{ color: 'text.secondary' }}>
                            {user?.phone ? base64Decode(user?.phone) : '-'}
                          </TableCell>
                          <TableCell sx={{ color: 'text.secondary' }}>
                            <Chip
                              label={user?.role?.roleName ? user.role.roleName : (user?.role?.name && typeof user?.role?.name === 'string' ? user.role.name : 'No Role')}
                              size="small"
                              variant="outlined"
                              sx={{
                                borderColor: theme.palette.primary.light,
                                color: theme.palette.primary.main,
                                bgcolor: 'rgba(25, 118, 210, 0.08)',
                                fontWeight: 500
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ color: 'text.secondary', maxWidth: 200 }}>
                            {Array.isArray(user.teams) && user.teams.length > 0 ? (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {user.teams.slice(0, 2).map((team: any, teamIdx: number) => (
                                  <Chip
                                    key={teamIdx}
                                    label={team.name}
                                    size="small"
                                    variant="filled"
                                    sx={{
                                      bgcolor: theme.palette.grey[100],
                                      color: theme.palette.text.secondary,
                                      fontSize: '0.75rem',
                                      height: 24
                                    }}
                                  />
                                ))}
                                {user.teams.length > 2 && (
                                  <Tooltip title={user.teams.slice(2).map((t: any) => t.name).join(', ')}>
                                    <Chip
                                      label={`+${user.teams.length - 2}`}
                                      size="small"
                                      variant="outlined"
                                      sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: '0.75rem',
                                        height: 24
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </Box>
                            ) : (
                              <Typography variant="body2" color="text.disabled">
                                No processes
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            {(() => {
                              const value = user?.status?.toLowerCase?.() || '';
                              let bgColor = theme.palette.grey[100];
                              let textColor = theme.palette.text.secondary;
                              let label = user?.status || 'Unknown';
                              
                              if (value === 'active') {
                                bgColor = 'rgba(76, 175, 80, 0.1)';
                                textColor = theme.palette.success.main;
                                label = 'Active';
                              } else if (value === 'inactive') {
                                bgColor = 'rgba(244, 67, 54, 0.1)';
                                textColor = theme.palette.error.main;
                                label = 'Inactive';
                              }
                              
                              return (
                                <Chip
                                  label={label}
                                  size="small"
                                  sx={{
                                    bgcolor: bgColor,
                                    color: textColor,
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    textTransform: 'capitalize',
                                    minWidth: 70,
                                    height: 28
                                  }}
                                />
                              );
                            })()}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7} align="center" sx={{ py: 8 }}>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="h6" color="text.secondary" gutterBottom>
                              No Users Found
                            </Typography>
                            <Typography variant="body2" color="text.disabled">
                              {search ? 'No users match your search criteria.' : 'No users available for the selected filters.'}
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )
          ) : (
            <Box 
              sx={{ 
                flex: 1,
                height: '600px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                bgcolor: 'grey.50',
                borderRadius: 1,
                m: 2,
                p: 4,
                border: '2px dashed',
                borderColor: 'grey.300'
              }}
            >
              <Typography variant="h6" color="text.secondary" gutterBottom>
                Select a Client
              </Typography>
              <Typography variant="body2" color="text.disabled">
                Choose a client from the dropdown above to view users
              </Typography>
            </Box>
          )}
        </Box>

        {/* Pagination */}
        <Box sx={{ borderTop: `1px solid ${theme.palette.divider}`, mt: 'auto' }}>
          <TablePagination
            component="div"
            count={count}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              '& .MuiTablePagination-toolbar': {
                px: 3,
                py: 2,
                minHeight: 64
              },
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                fontWeight: 500,
                color: 'text.secondary'
              }
            }}
          />
        </Box>
      </MainCard>
    </Box>
  );
};

export default Users;
